import { render, staticRenderFns } from "./index.vue?vue&type=template&id=435efa8f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&setup=true&"
export * from "./index.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./index.vue?vue&type=style&index=0&id=435efa8f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435efa8f",
  null
  
)

export default component.exports